import { createBrowserHistory } from 'history'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import Routes from './routes'
import { configureStore } from './store'
import { BrowserRouter } from "react-router-dom"
import { StrictMode } from 'react'
import React from 'react'

// Create browser history to use in the Redux store
//export const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string
export const history = createBrowserHistory()

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore(history)

// if (process.env.NODE_ENV === 'development') {
//     const whyDidYouRender = require("@welldone-software/why-did-you-render")
//     const ReactRedux = require("react-redux")
//     whyDidYouRender(React, {
//         trackAllPureComponents: true,
//      //   trackExtraHooks: [[require('react-redux/lib'), 'useSelector']],
//     })
// }
const container = document.getElementById('root')
if (container) {
    const root = createRoot(container)
    root.render(<Provider store={store}>
        <BrowserRouter>
            {/* <StrictMode> */}
            <Routes />
            {/* </StrictMode> */}
        </BrowserRouter>
    </Provider >)
}

//registerServiceWorker()
